const action = {
    GET_DATA: 'contact_type/GET_DATA',
    SET_DATA: 'contact_type/SET_DATA'
};

export default action